module.exports = __webpack_public_path__ + "img/clipboard.efb67327.svg";